import type { ProcessedFilters } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import type { GetSearchResultsFiltersVariables } from '@app/data/clients/rbServerSideClient/types';
import { EXPERIENCE } from '@app/data/clients/rbServerSideClient/utils/constants';
import { useCallback, useEffect, useState } from 'react';
import { refreshSrpFilters } from './refreshQueries/refreshSrpFilters';
import type { FilterState, SetFiltersType } from './types';

const cache = new Map<string, FilterState>();

export const useFilters = (
  filtersFragment: ProcessedFilters | null,
  resetUrl: string
) => {
  const [{ filters, optimisticOption, loading }, setFilters] =
    useState<SetFiltersType>({
      filters: filtersFragment,
      optimisticOption: undefined,
      loading: false,
    });

  useEffect(() => {
    setFilters((prevState) => ({ ...prevState, filters: filtersFragment }));
  }, [filtersFragment]);

  cache.set(resetUrl, {
    filters: filtersFragment,
  });

  const refresh = useCallback(
    (
      variables: GetSearchResultsFiltersVariables,
      url: string,
      checked?: boolean,
      button?: string
    ) => {
      if (variables.experience === EXPERIENCE.SRP)
        return refreshSrpFilters({
          callbackVariables: {
            variables,
            url,
            checked,
            button,
          },
          cache,
          setFilters,
        });

      if (variables.experience === EXPERIENCE.ARTIST_SHOP)
        setFilters((prevState) => ({
          ...prevState,
          optimisticOption: { name: button ?? '', checked: checked ?? false },
        }));
    },
    []
  );

  return {
    filters,
    optimisticOption,
    loading,
    refresh,
  };
};
